const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

const API_URL_LOCAL = process.env.REACT_APP_BASE_URL_LOCAL;
const API_URL_PROD = process.env.REACT_APP_BASE_URL_PROD;

// const DOMAIN_LOCAL = process.env.REACT_DOMAIN_LOCAL;
// const DOMAIN_PROD = process.env.REACT_DOMAIN_PROD;

const SOCKET_URL_LOCAL = process.env.REACT_APP_ONLINE_USER_URL_LOCAL;
const SOCKET_URL_PROD = process.env.REACT_APP_ONLINE_USER_URL_PROD_SOCKET;
const config = {
  base: {
    url: API_URL_LOCAL,
  },
  ws: {
    url: SOCKET_URL_LOCAL,
  },
  domain: ".localhost",
  ENVIRONMENT,
};

//CHECK FOR ENVIRONMENT
if (ENVIRONMENT === "prod") {
  config.base.url = API_URL_PROD;
  config.ws.url = SOCKET_URL_PROD;
  config.domain = "themajesticai.com";
} else {
  config.base.url = API_URL_LOCAL;
  config.ws.url = SOCKET_URL_LOCAL;
  config.domain = "localhost";
}

export { config, ENVIRONMENT };
